import { FC } from "react";
import DatePicker from "react-datepicker";
import { EOBsFilterProps } from "./types";
import { QueryParamsState } from "src/pages/EOBsListing/types";
import useFetch from "src/hooks/useFetch";
import { NPISpeciality } from "../enrollmentComp/prescriberForm/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ProductRequestProps } from "src/hooks/useDrugNameListing/types";
import HubInputField from "../inputType";
import { GroupBase, OptionsOrGroups } from "react-select";
import { Controller, useForm } from "react-hook-form";
import ReactInputMask from "react-input-mask";
import { US_STATES } from "src/constants";
import { format, parse } from "date-fns";
import {limitShift, offset, shift} from "@floating-ui/react";

const EOBsFilter: FC<EOBsFilterProps> = ({
    state,
    dispatch,
    onClearButtonClicked,
    handleSearchWithQueryParam
}): JSX.Element => {

    const { control, handleSubmit, reset, watch } = useForm<QueryParamsState>({
        mode: "all",
        defaultValues: state,
    });
    const { data: specialityData } = useFetch<NPISpeciality[]>(APIEndpoints.GET_PROVIDER_SPECIALITIES);
    const { data: productData } = useFetch<ProductRequestProps[]>(APIEndpoints.GET_PRODUCTS);


    const dateFromValue = watch("date_from");
    const dateToValue = watch("date_to");

    const searchForCaseListing = (values: QueryParamsState) => {
        handleSearchWithQueryParam(values)
    };

    const clearFilter = () => {
        onClearButtonClicked()
        reset()
    }

    const Insurance_MAC: string[] = ["CGS Administrators", "First Coast", "National Government Services", "Noridian", "Novitas", "Palmetto GBA", "WPS"]
    const Insurance_Type: string[] = ['Commercial', 'Medicare', 'Managed Medicare', 'Medicaid', 'Managed Medicaid', 'Other','Government']
    return (
        <>
            <form onSubmit={handleSubmit(searchForCaseListing)}>
                <div className="row g-2 statistics-filter">
                    <div className="col-6 col-md-2 date-col">
                        <Controller
                            name="date_from"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    selected={
                                        field.value
                                            ? parse(field.value, "yyyy-MM-dd", new Date()) // Parse default yyyy-MM-dd to a Date
                                            : null
                                    }
                                    onChange={(date) => {
                                        field.onChange(date ? format(date, "yyyy-MM-dd") : ""); // Convert back to yyyy-MM-dd for consistency
                                    }}
                                    dateFormat="MM/dd/yyyy" // User-facing format
                                    className={`form-control ${error?.message ? "is-invalid" : ""}`}
                                    placeholderText="mm/dd/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    isClearable
                                    customInput={
                                        <ReactInputMask mask="99/99/9999">
                                            {(inputProps: {}) => <input {...inputProps} />}
                                        </ReactInputMask>
                                    }
                                    maxDate={dateToValue ? parse(dateToValue, "yyyy-MM-dd", new Date()) : undefined}
                                    wrapperClassName="w-100"
                                    portalId="root"
                                    popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
                                />
                            )}
                        />
                    </div>
                    <div className="col-6 col-md-2 date-col">
                        <Controller
                            name="date_to"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    selected={
                                        field.value
                                            ? parse(field.value, "yyyy-MM-dd", new Date()) // Parse default yyyy-MM-dd to a Date
                                            : null
                                    }
                                    onChange={(date) => {
                                        field.onChange(date ? format(date, "yyyy-MM-dd") : ""); // Convert back to yyyy-MM-dd for consistency
                                    }}
                                    dateFormat="MM/dd/yyyy" // User-facing format
                                    className={`form-control ${error?.message ? "is-invalid" : ""}`}
                                    placeholderText="mm/dd/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    isClearable
                                    customInput={
                                        <ReactInputMask mask="99/99/9999">
                                            {(inputProps: {}) => <input {...inputProps} />}
                                        </ReactInputMask>
                                    }
                                    minDate={dateFromValue ? parse(dateFromValue, "yyyy-MM-dd", new Date()) : undefined}
                                    wrapperClassName="w-100"
                                    portalId="root"
                                    popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
                                />
                            )}
                        />
                    </div>
                    <div className="col col-md-2 insurance-name">
                        <Controller
                            name="insurance_name"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_name"
                                    isRowBased={true}
                                    isRowInsideAnother={true}
                                    isRequired={false}
                                    field={field}
                                    inputPlaceholder="Insurance Name"
                                    error={error}
                                />
                            )}
                        />
                    </div>
                    <div className="col col-md-3 mac-col">
                        <Controller
                            name="insurance_mac"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_mac"
                                    isRequired={true}
                                    isRowBased={true}
                                    isRowInsideAnother={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={true}
                                    inputPlaceholder="(MAC) Medicare Administrative Contractor"
                                    dropdownData={
                                        (Insurance_MAC &&
                                            Insurance_MAC
                                                .map((item) => item.replace(/°/g, "").replace(/"/g, "").trim()) // Clean ° and " from each string
                                                .filter((item) => item !== "") // Remove empty items
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName,
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />


                    </div>
                    <div className="col col-md-3 insurance-col">
                        <Controller
                            name="insurance_type"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_type"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={true}
                                    inputPlaceholder="Insurance Type"
                                    dropdownData={
                                        (Insurance_Type &&
                                            Insurance_Type
                                                .map((item) => item.replace(/°/g, "").replace(/"/g, "").trim()) // Clean ° and " from each string
                                                .filter((item) => item !== "") // Remove empty items
                                                .map((cleanName) => ({
                                                    value: cleanName
                                                        //.replace(/other/gi, "")           // Remove "other", case-insensitive
                                                        .trim()                            // Trim again in case "other" was at start/end
                                                        .toLowerCase()
                                                        .replace(/\s+/g, "_"),
                                                    label: cleanName,
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col col-md-3 ps-col">
                        <Controller
                            name="doctor_taxonomy"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="doctor_taxonomy"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={true}
                                    inputPlaceholder="Provider Speciality ..."
                                    dropdownData={
                                        (specialityData ?
                                            specialityData.map((item) => ({
                                                value: item.code.toLowerCase(),
                                                label: item.name.toLowerCase() === "zilretta" ? item.name.toUpperCase() : item.name.replace(/°/g, "")
                                            })).map(
                                                (procedure) => ({ value: procedure.value, label: procedure.label })
                                            ) : []
                                        ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col col-md-2 product-col">
                        <Controller
                            name="product"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="product"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Product ..."
                                    dropdownData={
                                        (productData ?
                                            productData.map((item) => ({
                                                value: item.name.toLowerCase(),
                                                label: item.name.toLowerCase() === "zilretta" ? item.name.toUpperCase() : item.name.replace(/°/g, "")
                                            })).map(
                                                (procedure) => ({ value: procedure.value, label: procedure.label })
                                            ) : []
                                        ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-6 col-md-2">
                        <Controller
                            name="cpt_codes"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="cpt_codes"
                                    isRowBased={true}
                                    isRowInsideAnother={true}
                                    isRequired={false}
                                    field={field}
                                    inputPlaceholder="CPT Codes"
                                    error={error}
                                />
                            )}
                        />
                    </div>
                    <div className="col-6 col-md-2 state-col">
                        <Controller
                            name="insurance_state"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_state"
                                    isRequired={true}
                                    inputPlaceholder="State ..."
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={true}
                                    dropdownData={
                                        US_STATES.map(
                                            (item) => ({ value: item.value, label: item.value })
                                        ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col col-md-2 btn-col d-flex align-items-start gap-2">
                        <button type="submit" className="btn btn-primary">Find</button>
                        <button type="button" onClick={() => clearFilter()} className="btn btn-outline-secondary">
                            Clear
                        </button>
                    </div>
                </div>
            </form>
        </>

    );
};

export default EOBsFilter;
